var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"autocomplete-list-item__link",attrs:{"title":_vm.title,"data-qa":_vm.item.dataQa}},[_vm._v("\n  "+_vm._s(_vm.item[_vm.displayField])+"\n  "),(_vm.hasSubtitle)?_c('div',{staticClass:"autocomplete-list-item__sub"},[_vm._v("\n    "+_vm._s(_vm.item[_vm.subDisplayField])+"\n  ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }